var React = require('react');

function BellIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Shape"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":2},React.createElement("g",{"id":"Icons-/-Bells-/-Outline","transform":"translate(-2.000000, 0.000000)","stroke":"#5E5E5E","strokeWidth":"1.5"},React.createElement("path",{"d":"M10,21.75 C10.260886,22.6387095 11.0762894,23.2491541 12.0025,23.2491541 C12.9287106,23.2491541 13.744114,22.6387095 14.005,21.75 M12,3 L12,0.75 M12,3 C16.1421356,3 19.5,6.35786438 19.5,10.5 C19.5,17.546 21,18.75 21,18.75 L3,18.75 C3,18.75 4.5,16.834 4.5,10.5 C4.5,6.35786438 7.85786438,3 12,3 Z","id":"Shape"})))]);
}

BellIcon.defaultProps = {"width":"20px","height":"24px","viewBox":"0 0 20 24","version":"1.1"};

module.exports = BellIcon;

BellIcon.default = BellIcon;
